import React from 'react';
import { Layout } from '@/components/layout';
import SEO from '@/components/shared/SEO';
import { OrganizationSchema } from '@/components/shared/JsonLdSchemas';
import {
  HeroSection,
  MetricsSection,
  WhyPorticoSection,
  ZoneSelectorSection,
  SustainabilitySection,
  TestimonialSection,
  FinalCTASection
} from '@/components/home';
import SeoContentBlock from '@/components/shared/SeoContentBlock';
import { HOME_SEO } from '@/content/seoContentCopy';

const HomePage = () => {
  return (
    <Layout>
      <SEO
        title="Entrance Systems & High Performance Commercial Flooring"
        description="Portico Systems engineers commercial entrance systems, entrance mat systems, grid systems, and commercial flooring solutions — entry mats, carpet tiles, LVT, custom logo mats, and non-slip kitchen flooring. Protect your floors, prevent slips and falls, and roll out chain store flooring nationally with our Zone Defense System."
        canonicalUrl="/"
        keywords={[
          "Entrance Systems",
          "Commercial Entrance Flooring",
          "Commercial Entryway Systems",
          "Entrance Mat Systems",
          "Entrance Tiles",
          "Grid Systems",
          "Floor Protection",
          "Floor Safety",
          "Safer Floors",
          "Slip and Fall Prevention",
          "Non Slip Kitchen Flooring",
          "Grocery Store Flooring",
          "Grocery Store Entrance Mats",
          "Retail Flooring Solutions",
          "Retail Flooring Installation",
          "Chain Store Flooring Solutions",
          "National Flooring Rollouts",
          "Commercial Flooring Solutions",
          "Installation Services",
          "Comfort at Work"
        ]}
      />
      <OrganizationSchema />
      <HeroSection />
      <MetricsSection />
      <WhyPorticoSection />
      <ZoneSelectorSection />
      <SustainabilitySection />
      <TestimonialSection />
      <SeoContentBlock {...HOME_SEO} />
      <FinalCTASection />
    </Layout>
  );
};

export default HomePage;
